import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

export function NotFound() {
  const { t } = useTranslation();
  return (
    <section className="space-y-4 text-center">
      <h1 className="font-display text-title font-bold">404</h1>
      <p className="text-ink-muted">{t('error.notFound')}</p>
      <Link to="/" className="underline">
        {t('app.name')}
      </Link>
    </section>
  );
}
